module.exports = __webpack_public_path__ + "img/1440.a3e39d6c.jpg";